module.exports = __webpack_public_path__ + "img/icon-supply2.cf8341c9.png";